import React, { useState, useEffect } from "react";
import Sidebaradmin from "./Sidebar";
import Navbaradmin from "./navbar";
import CreatePostForm from "./CreatePost"; // Remove if not used

const initialPosts = [];

export default function Post() {
  const [posts, setPosts] = useState(initialPosts);
  const [search, setSearch] = useState("");
  const [editingPost, setEditingPost] = useState(null);
  const [previewMode, setPreviewMode] = useState(false);

  // Fetch posts from API
  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await fetch("/api/admin/posts");
        const data = await response.json();
        setPosts(data); // Set fetched posts to state
      } catch (error) {
        console.error("Error fetching posts:", error);
      }
    };
    fetchPosts();
  }, []); // Empty dependency array ensures this effect runs once when the component mounts

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  const filteredPosts = posts.filter(
    (post) =>
      post.title.toLowerCase().includes(search.toLowerCase()) ||
      post.content.toLowerCase().includes(search.toLowerCase())
  );

  const handleAddPost = async (newPost) => {
    try {
      const response = await fetch("/api/posts", {
        method: "POST", // Create post with POST method
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(newPost),
      });
      const addedPost = await response.json();
      setPosts([...posts, addedPost]); // Update the posts state with the new post
      setEditingPost(null); // Reset editing state
    } catch (error) {
      console.error("Error adding post:", error);
    }
  };

  const handleUpdatePost = async (updatedPost) => {
    try {
      const response = await fetch(`/api/posts/${editingPost._id}`, {
        method: "PUT", // Update post with PUT method
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updatedPost),
      });
      const data = await response.json();
      setPosts(
        posts.map((post) => (post._id === data._id ? { ...data } : post)) // Update the post in the state
      );
      setEditingPost(null); // Reset editing state
    } catch (error) {
      console.error("Error updating post:", error);
    }
  };

  const handleDeletePost = async (id) => {
    try {
      await fetch(`/api/posts/${id}`, {
        method: "DELETE",
      });
      setPosts(posts.filter((post) => post._id !== id)); // Remove the deleted post from the state
    } catch (error) {
      console.error("Error deleting post:", error);
    }
  };

  return (
    <div className="flex flex-col md:flex-row min-h-screen bg-gray-100">
      <Sidebaradmin />

      <div className="flex-1 flex flex-col overflow-hidden">
        <Navbaradmin />

        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-200 p-6">
          <div className="bg-white p-6 rounded-lg shadow-lg mb-6">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              Manage Posts
            </h2>

            <div className="mb-6 flex gap-4">
              <input
                type="text"
                placeholder="Search posts..."
                className="w-full p-3 rounded-lg border border-gray-300 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={search}
                onChange={handleSearch}
              />
              <button
                className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition duration-200 ease-in-out shadow-md"
                onClick={() =>
                  setEditingPost({ title: "", content: "", status: "draft" }) // Exclude _id for new post
                }
              >
                New Post
              </button>
            </div>

            <div className="mb-6">
              {editingPost && (
                <CreatePostForm
                  post={editingPost}
                  onSubmit={editingPost._id ? handleUpdatePost : handleAddPost} // Decide if it's an update or create
                  onCancel={() => setEditingPost(null)}
                  previewMode={previewMode}
                  setPreviewMode={setPreviewMode}
                  formTitle={editingPost._id ? "Update Post" : "Create Post"}
                />
              )}

              {previewMode && editingPost && (
                <div className="preview bg-gray-50 p-6 rounded-lg shadow-lg mb-6">
                  <h3 className="text-xl font-semibold mb-4">
                    {editingPost.title}
                  </h3>
                  <div
                    dangerouslySetInnerHTML={{ __html: editingPost.content }}
                  ></div>
                </div>
              )}

              <table className="table-auto w-full text-left bg-white shadow-lg rounded-lg">
                <thead>
                  <tr className="bg-gray-200 text-gray-700">
                    <th className="p-4">Title</th>
                    <th className="p-4">Date</th>
                    <th className="p-4">Status</th>
                    <th className="p-4">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredPosts.map((post) => (
                    <tr key={post._id} className="border-t">
                      <td className="p-4">{post.title}</td>
                      <td className="p-4">
                        {post.date
                          ? new Date(post.date).toLocaleDateString()
                          : "N/A"}
                      </td>
                      <td className="p-4">{post.status}</td>
                      <td className="p-4">
                        <button
                          className="bg-yellow-500 text-white px-3 py-1 rounded-lg hover:bg-yellow-600 transition duration-200 ease-in-out"
                          onClick={() => setEditingPost(post)} // Set the post to editing mode
                        >
                          Edit
                        </button>
                        <button
                          className="bg-red-500 text-white px-3 py-1 rounded-lg hover:bg-red-600 transition duration-200 ease-in-out ml-2"
                          onClick={() => handleDeletePost(post._id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
